import React from 'react'
import { Control } from 'react-redux-form'
import { t } from 'ttag'

import Form from '../../../../components/form/Form'
import Field from '../../../../components/form/Field'

const TextQuestionForm = ({ onSave, onCancel, userOptions, validationOptions }) => {
  const formModel = 'survey.surveyForms.surveyTextQuestionForm'
  const model = path => `${formModel}.${path}`

  return (
    <Form
      model={formModel}
      onSubmit={form => {
        onSave(form)
      }}>
      {form => (
        <div>
          <Field
            model={model(`name`)}
            form={form}
            required={true}
            label={t`Question Title`}
            type="text"
          />

          <Field
            model={model(`description`)}
            form={form}
            label={t`Description`}
            type="textarea"
          />

          <Field
            model={model(`responseRequired`)}
            form={form}
            label={t`Response Required`}
            type="checkbox"
          />

          <Field
            model={model(`multiLine`)}
            form={form}
            label={t`Allow Multiple Lines`}
            type="checkbox"
          />

          <div className="row">
            <div className="col-xs-6">
              <Field
                model={model(`minLength`)}
                form={form}
                label={t`Min Length (characters)`}
                type="text"
              />
            </div>
            <div className="col-xs-6">
              <Field
                model={model(`maxLength`)}
                form={form}
                label={t`Max Length (characters)`}
                type="text"
              />
            </div>
          </div>

          <Field
            model={model('validationOptions')}
            form={form}
            label={t`Validate input is`}
            control={Control.select}>
            {(validationOptions || []).map(v => (
              <option key={`${v.id}--validate`} value={v.id}>
                {v.label}
              </option>
            ))}
          </Field>

          <Field
            model={model('userDefaultOptions')}
            form={form}
            label={t`Pre-Fill field with`}
            control={Control.select}>
            <option value="">None</option>
            {(userOptions || []).map(v => (
              <option key={`${v.id}--prefill`} value={v.id}>
                {v.label}
              </option>
            ))}
          </Field>

          <div className="nav" style={{ marginTop: '1em' }}>
            <input type="submit" className="submit" value={t`Save Question`} />
            &nbsp;
            <button type="button" onClick={onCancel} className="cancel">
              {t`Cancel`}
            </button>
          </div>
        </div>
      )}
    </Form>
  )
}

export default TextQuestionForm
